<template>
  <div class="page">
    <a-card title="拼团详情" :bordered="false" :bodyStyle="{paddingTop:'0px'}"
            :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
      <a-card :bordered="false" :headStyle="{borderBottom:'0px',paddingLeft:'0px'}" :bodyStyle="{padding:'0px'}">
        <a-row slot="title">
          <a-col :span="8">
            <span class="card-title">拼团信息</span>
          </a-col>
        </a-row>
        <a-table
          :columns="getGroupsColumns()"
          rowKey="groupId"
          :dataSource="orderInfoList" :pagination="false">
          <span slot="planSlots" slot-scope="text,record">
            <span>{{ record.groupParticipateQuantity }}/{{ record.groupSucceedQuantity }}</span>
          </span>
          <span slot="action" slot-scope="text,record" v-if="record.groupStatus==0">
            <a-popconfirm title="是否要强制成功？" @confirm="onCoerceOrder(record.groupId,1)">
              <a>强制成功</a>
            </a-popconfirm>
            <a-divider type="vertical"/>
            <a-popconfirm title="是否要强制失败？" @confirm="onCoerceOrder(record.groupId,2)">
              <a>强制失败</a>
            </a-popconfirm>
          </span>
        </a-table>
      </a-card>
      <a-card :bordered="false" :headStyle="{borderBottom:'0px',paddingLeft:'0px'}" :bodyStyle="{padding:'0px'}">
        <a-row slot="title">
          <a-col :span="8">
            <span class="card-title">订单明细信息</span>
          </a-col>
        </a-row>
        <custom-page-table
          ref="table"
          rowKey="joinOrderNo"
          :queryParams="orderQueryParams"
          :columns="getOrdersColumns()"
          :request-promise="getListPromise"
        >
          <template slot="personSlots" slot-scope="rowItem">
            <div>{{ rowItem.record.orderContactName }}</div>
            <div>{{ rowItem.record.orderContactPhone }}</div>
          </template>
          <span slot="action" slot-scope="rowItem" v-if="rowItem.record.orderStatus == 1">
            <a-popconfirm title="是否要确认订单？" @confirm="confirmUpdate(rowItem.record.joinOrderNo,0)"
                          @cancel="cancel">
              <a :disabled="isDisabled">确认订单</a>
            </a-popconfirm>
            <a-divider type="vertical"/>
            <a-popconfirm title="是否要拒绝订单？" @confirm="confirmUpdate(rowItem.record.joinOrderNo,1)"
                          @cancel="cancel">
              <a :disabled="isDisabled">拒绝订单</a>
            </a-popconfirm>
          </span>
        </custom-page-table>
      </a-card>
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'GroupOrderDetails',
  components: {},
  data() {
    return {
      groupId: this.$route.query.groupId,
      submitLoading: false,
      queryParams: {},
      orderQueryParams: {
        groupId: this.$route.query.groupId
      },
      orderInfoList: [],
      isDisabled: false
    }
  },
  mounted() {

  },
  activated() {
    this.getLogUtils().logWithTag('拼团activated')
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'GroupServiceList', title: '拼团商品' },
      { name: 'GroupOrderList', title: '拼团订单' }
    ])
    this.groupId = this.$route.query.groupId
    this.getDetailInfo()
  },
  watch: {
    groupId(val) {
      this.orderQueryParams.groupId = val
      this.$refs.table.refresh(true)
    }
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getOrderService().post('group/order/detail/List', params)
    },
    getDetailInfo() {
      this.getHttpServices().getOrderService().post('group/order/detailInfo', {
        groupId: this.groupId
      }).then(res => {
        this.getLogUtils().logWithTag('getDetailInfo', res)
        if (res) {
          this.orderInfoList = [res]
          this.getLogUtils().logWithTag('getDetailInfo', this.orderInfoList)
          this.$refs.table.refresh(true)
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getGroupsColumns() {
      return [
        {
          title: '创建时间',
          dataIndex: 'groupCreateTime'
        },
        {
          title: '结束时间',
          dataIndex: 'groupMaturityTime'
        },
        {
          title: '商品名称',
          dataIndex: 'groupProName'
        },
        {
          title: '拼团套餐',
          dataIndex: 'groupOptionName'
        },
        {
          title: '拼团进度',
          dataIndex: '',
          scopedSlots: { customRender: 'planSlots' }
        },
        {
          title: '拼团状态',
          dataIndex: 'groupStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '190px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getOrdersColumns() {
      return [
        {
          title: '订单编号',
          dataIndex: 'joinOrderNo'
        },
        {
          title: '金额',
          dataIndex: 'orderSellAmount'
        },
        {
          title: '联系人',
          dataIndex: 'orderContactName',
          scopedSlots: { customRender: 'personSlots' }
        },
        {
          title: '下单时间',
          dataIndex: 'orderCreateTime'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '190px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    // 强制成功、失败
    onCoerceOrder(groupId, groupStatus) {
      this.getHttpServices().getPayApiService().post('order/operating/group', {
        groupId: this.groupId,
        groupStatus: groupStatus
      }).then(res => {
        this.getLogUtils().logWithTag('onCoerceOrder', res)
        this.$message.success('后台处理中，请稍后查看')
        setTimeout(() => {
          this.$router.push({
            name: 'GroupOrderList',
            query: {
              serverUniqueId: this.$route.query.serverUniqueId,
              updateFlag: true
            }
          })
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    confirmUpdate(orderNo, status) {
      let str = status == 0 ? '确认' : '拒绝'
      this.isDisabled = true
      this.getHttpServices().getPayApiService().post('order/operateOrder', {
        operateType: status,
        orderNo: orderNo,
        orderProviderRemark: ''
      }).then(res => {
        this.getLogUtils().logWithTag('confirmUpdate', res)
        this.$message.success(str + '订单成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.isDisabled = false)
    },
    cancel() {
      this.isDisabled = false
    }
  }
}
</script>
<style scoped lang="less">
@import url('../../../CustomPage.less');

.ant-btn + .ant-btn {
  margin-left: 10px;
}

.maxW250 {
  max-width: 250px;
}

.pl5 {
  padding-left: 5px;
}

.pr5 {
  padding-right: 5px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}
</style>